// extracted by mini-css-extract-plugin
export default {"Container":"Notifications_Container__P-y4S","wrapper":"Notifications_wrapper__m29BO","right":"Notifications_right__syd-P","Notifications":"Notifications_Notifications__vqnB9"};